import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class BilDashboardService {
    constructor(http) {
        this.http = http;
    }
    getApplicationData() {
        if (localStorage.getItem('isPayLater')) {
            return this.http.get(environment.basePath + '/dashboard/dsk/application/PL');
        }
        else {
            return this.http.get(environment.basePath + '/dashboard/dsk/application/bil');
        }
    }
    getTechInfoStatus() {
        return this.http.get(environment.basePath + '/dashboard/getTechInfoStatus');
    }
    getFIApplicationData() {
        return this.http.get(environment.url + '/bil-fi/application/details?fiName=LK');
    }
}
BilDashboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BilDashboardService_Factory() { return new BilDashboardService(i0.ɵɵinject(i1.HttpClient)); }, token: BilDashboardService, providedIn: "root" });
